import * as React from "react";


const columns = [
    {
        field: "index",
        label: "LP",
        sort: "desc",
        type: "index",
        width: 53,
    },
    {
        field: "upperToolNumber",
        label: "pairingReportPage.toolNumber",
        sort: "desc",
        width: 53,
        type: "custom",
        custom: (c, row) => row.upperTool?.toolNumber,
    },
    {
        field: "upperLabelling",
        label: "pairingReportPage.topPunchMarking",
        sort: "desc",
        type: "custom",
        custom: (c, row) => row.upperTool?.labelling,
        width: 53,
    },
    {
        field: "upperToolMeasure",
        label: "pairingReportPage.topPunchLength",
        sort: "desc",
        width: 53,
    },
    {
        field: "lowerToolNumber",
        parentField: "toolNumber",
        label: "pairingReportPage.bottomPunchNumber",
        sort: "desc",
        type: "custom",
        custom: (c, row) => row.lowerTool?.toolNumber,
        width: 53,

    },
    {
        field: "lowerLabelling",
        parentField: "labelling",
        label: "pairingReportPage.punchMarking",
        sort: "desc",
        type: "custom",
        custom: (c, row) => row.lowerTool?.labelling,
        width: 53,
    },
    {
        field: "lowerToolMeasure",
        label: "pairingReportPage.punchLength",
        sort: "desc",
        width: 53,
    }


    ];


export default columns;